// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results__top{
    padding: 1.7em 0 2.85em;
    text-align: center;
}
.results__topScore{
    font-weight: 500;
    font-size: 1.875em;
    line-height: 1.36666;
    margin-bottom: 0.5rem;
}
.results__topText{
    font-size: 0.9375em;
    line-height: 1.33333;
}
.results{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 0.9em;
}
.results__item{
    opacity: 0.25;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 9.1em;
    margin: 0 0.5em 2.1em;
    position: relative;
}
.results__item.correct{
    z-index: 2;
    opacity: 1;
}
.results__ava{
    position: relative;
    border-radius: 100%;
    width: 5.875em;
    height: 5.875em;
    background: #161616;
    margin-bottom: 0.3em;
}
.results__ico{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}
.correct .results__ava{
    background: #009465;
}
.results__text{
    display: none;
}
.results__name{
    line-height: 1.25;
    font-weight: 500;
}
.results__btn{
    width: 8.625em;
    margin: 0 auto 3.6875em;
}
@media(min-width: 100vh){
    .results__top{
        padding: 1.8em 0;
    }
    .results__topScore{
        font-size: 3em;
        line-height: 1.208;
        font-weight: 700;
        margin-bottom: 0.15rem;
    }
    .results__topText{
        font-size: 0.75em;
    }
    .results{
        margin: 0;
    }
    .results__item{
        margin: 0;
        background: #fff;
        border-radius: 1em;
        color: #000;
        align-items: flex-start;
        width: 12.8125em;
        min-height: 16.875em;
        padding: 1.375em 1.125em;
        text-align: left;
        opacity: 0.2;
        box-shadow: 0 0 0.5em rgba(0,0,0,0.1);
    }
    .results__ava{
        width: 4.8125em;
        height: 4.8125em;
        margin-bottom: 0.9em;
    }
    .results__text{
        display: block;
        font-size: 0.614994375em;
        line-height: 1.22;
        padding: 0 0.1rem;
    } 
    .results__itemWrapper{
        position: absolute;
        left: 50%;
        top: 0;
    }
    .correct .results__ava,
    .results__ava{
        background: #D7D3F1;
    }
    .results__name{
        font-weight: 700;
        font-size: 1.233em;
        line-height: 1.27;
        margin-bottom: 0.65rem;
        padding: 0 0.1rem;
        max-width: 6.8em;
    }
    .resultsWrapper{
        position: relative;
    }
    .results__itemWrapper:nth-child(1){
        margin-top: 4.3em;
        margin-left: -34.4em;
    }
    .results__itemWrapper:nth-child(1) .results__item{
        transform: rotate(6.59deg);        
    }
    .results__itemWrapper:nth-child(2){
        margin-top: 11.3em;
        margin-left: -22.5em;
    }
    .results__itemWrapper:nth-child(2) .results__item{
        transform: rotate(-11.44deg);        
    }
    .results__itemWrapper:nth-child(3){
        margin-top: 4.1em;
        margin-left: -12.9em;
    }
    .results__itemWrapper:nth-child(3) .results__item{
        transform: rotate(4.06deg);        
    }
    .results__itemWrapper:nth-child(4){
        margin-top: 10.7em;
        margin-left: -0.1em;
    }
    .results__itemWrapper:nth-child(4) .results__item{
        transform: rotate(13.78deg);        
    }
    .results__itemWrapper:nth-child(5){
        margin-top: 0.4em;
        margin-left: 9.6em;
    }
    .results__itemWrapper:nth-child(5) .results__item{
        transform: rotate(-11.44deg);        
    }
    .results__btn{
        width: 12.375em;
        position: absolute;
        left: 50%;
        top: 0;
        margin-top: 10.9em;
        margin-left: 25em;
    }
}
@media(min-width: 100vh) and (max-width: 140vh){
    .results__btn{
        margin-top: 21em;
        margin-left: 14em;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/Results/results.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;QACT,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,uBAAuB;QACvB,gBAAgB;QAChB,oBAAoB;QACpB,wBAAwB;QACxB,gBAAgB;QAChB,YAAY;QACZ,qCAAqC;IACzC;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,cAAc;QACd,wBAAwB;QACxB,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,MAAM;IACV;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,SAAS;QACT,MAAM;QACN,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".results__top{\n    padding: 1.7em 0 2.85em;\n    text-align: center;\n}\n.results__topScore{\n    font-weight: 500;\n    font-size: 1.875em;\n    line-height: 1.36666;\n    margin-bottom: 0.5rem;\n}\n.results__topText{\n    font-size: 0.9375em;\n    line-height: 1.33333;\n}\n.results{\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: 0.9em;\n}\n.results__item{\n    opacity: 0.25;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    width: 9.1em;\n    margin: 0 0.5em 2.1em;\n    position: relative;\n}\n.results__item.correct{\n    z-index: 2;\n    opacity: 1;\n}\n.results__ava{\n    position: relative;\n    border-radius: 100%;\n    width: 5.875em;\n    height: 5.875em;\n    background: #161616;\n    margin-bottom: 0.3em;\n}\n.results__ico{\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}\n.correct .results__ava{\n    background: #009465;\n}\n.results__text{\n    display: none;\n}\n.results__name{\n    line-height: 1.25;\n    font-weight: 500;\n}\n.results__btn{\n    width: 8.625em;\n    margin: 0 auto 3.6875em;\n}\n@media(min-width: 100vh){\n    .results__top{\n        padding: 1.8em 0;\n    }\n    .results__topScore{\n        font-size: 3em;\n        line-height: 1.208;\n        font-weight: 700;\n        margin-bottom: 0.15rem;\n    }\n    .results__topText{\n        font-size: 0.75em;\n    }\n    .results{\n        margin: 0;\n    }\n    .results__item{\n        margin: 0;\n        background: #fff;\n        border-radius: 1em;\n        color: #000;\n        align-items: flex-start;\n        width: 12.8125em;\n        min-height: 16.875em;\n        padding: 1.375em 1.125em;\n        text-align: left;\n        opacity: 0.2;\n        box-shadow: 0 0 0.5em rgba(0,0,0,0.1);\n    }\n    .results__ava{\n        width: 4.8125em;\n        height: 4.8125em;\n        margin-bottom: 0.9em;\n    }\n    .results__text{\n        display: block;\n        font-size: 0.614994375em;\n        line-height: 1.22;\n        padding: 0 0.1rem;\n    } \n    .results__itemWrapper{\n        position: absolute;\n        left: 50%;\n        top: 0;\n    }\n    .correct .results__ava,\n    .results__ava{\n        background: #D7D3F1;\n    }\n    .results__name{\n        font-weight: 700;\n        font-size: 1.233em;\n        line-height: 1.27;\n        margin-bottom: 0.65rem;\n        padding: 0 0.1rem;\n        max-width: 6.8em;\n    }\n    .resultsWrapper{\n        position: relative;\n    }\n    .results__itemWrapper:nth-child(1){\n        margin-top: 4.3em;\n        margin-left: -34.4em;\n    }\n    .results__itemWrapper:nth-child(1) .results__item{\n        transform: rotate(6.59deg);        \n    }\n    .results__itemWrapper:nth-child(2){\n        margin-top: 11.3em;\n        margin-left: -22.5em;\n    }\n    .results__itemWrapper:nth-child(2) .results__item{\n        transform: rotate(-11.44deg);        \n    }\n    .results__itemWrapper:nth-child(3){\n        margin-top: 4.1em;\n        margin-left: -12.9em;\n    }\n    .results__itemWrapper:nth-child(3) .results__item{\n        transform: rotate(4.06deg);        \n    }\n    .results__itemWrapper:nth-child(4){\n        margin-top: 10.7em;\n        margin-left: -0.1em;\n    }\n    .results__itemWrapper:nth-child(4) .results__item{\n        transform: rotate(13.78deg);        \n    }\n    .results__itemWrapper:nth-child(5){\n        margin-top: 0.4em;\n        margin-left: 9.6em;\n    }\n    .results__itemWrapper:nth-child(5) .results__item{\n        transform: rotate(-11.44deg);        \n    }\n    .results__btn{\n        width: 12.375em;\n        position: absolute;\n        left: 50%;\n        top: 0;\n        margin-top: 10.9em;\n        margin-left: 25em;\n    }\n}\n@media(min-width: 100vh) and (max-width: 140vh){\n    .results__btn{\n        margin-top: 21em;\n        margin-left: 14em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
